<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item label="检查项">
          <el-select v-model="formInline.electronic_waybill_item_id" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in itemList" :key="index" :label="item.name" :value="item.electronic_waybill_item_id"></el-option>
          </el-select>
        </el-form-item> 
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>-->

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加电子运单</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <!-- <el-table-column prop="name" label="检查项"></el-table-column> -->
            <el-table-column prop="ew_time" label="记录时间"></el-table-column>
            <!-- <el-table-column prop="type" label="管理方式">
              <template slot-scope="scope">
                {{ scope.row.type === 1 ? '线上' : (scope.row.type === 0 ? '线下' : '未知') }}
              </template>
            </el-table-column> -->
            <el-table-column prop="certificate_w" label="上传文件">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :href="scope.row.certificate_w"
                  target="_blank"
                >
                  下载文件
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="user_name" label="管理员名称" width="150"></el-table-column>
            <el-table-column prop="nickName" label="用户名称" width="150"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column prop="update_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :electronic_waybill_id="electronic_waybill_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import AfuncApi from '@/api/afunc.js'
  import Electronic_waybillApi from '@/api/electronic_waybill.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        itemList:[],
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          electronic_waybill_item_id:''
        },

        open_add:false,
        open_edit:false,
        electronic_waybill_id:"",
        dialogVisible:false,
      };
    },
    created() {
      this.loadElectronicWaybill();
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//电子运单标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Electronic_waybillApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },
      async loadElectronicWaybill() {
        try {
          const response = await AfuncApi.call({
            model: 'electronic_waybill_item',
            action: 'index',
            page: 1,
            list_rows: 1000
          })
          
          if (response.code === 1 && response.data.list) {
            this.itemList = response.data.list.data || []
          }
        } catch (error) {
          console.error('加载检查项列表失败:', error)
          this.$message.error('加载检查项列表失败')
        }
      },

      /*编辑活动*/
      editClick(row) {
        this.electronic_waybill_id = row.electronic_waybill_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Electronic_waybillApi.del(
              {
                electronic_waybill_id: row.electronic_waybill_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/electronic_waybill/index/index.vue